import { create } from "zustand";
import type { UserInfo } from "../types/auth.types";

interface AuthStore {
  user: UserInfo | null;
  token: string | null;
  isAuthenticated: boolean;

  setUser: (user: UserInfo) => void;
  logout: () => void;
  initialize: () => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  token: null,
  isAuthenticated: false,

  setUser: (user) => {
    localStorage.setItem("userInfo", JSON.stringify(user));
    localStorage.setItem("authToken", user.token);
    set({ user, token: user.token, isAuthenticated: true });
  },

  logout: () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userInfo");
    set({ user: null, token: null, isAuthenticated: false });
  },

  initialize: () => {
    const token = localStorage.getItem("authToken");
    const userInfoStr = localStorage.getItem("userInfo");
    if (token && userInfoStr) {
      try {
        const user = JSON.parse(userInfoStr) as UserInfo;
        set({ user, token, isAuthenticated: true });
      } catch {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userInfo");
      }
    }
  },
}));
